'use client';

import { useStore } from 'zustand';
import { faSearch } from '@fortawesome/pro-light-svg-icons';

import { Input } from '@/components/ui/input/input.component';
import { InputProps } from '@/components/ui/input/input.types';
import { useSearchState } from '@/store/search/search.store';
import { Search } from '@/app/(main)/(pages)/_components/search/search.component';

interface SearchEntityInputProps extends InputProps {
  onOpen?: () => void;
}

export function SearchEntityInput({ onOpen, ...props }: SearchEntityInputProps) {
  const selectedSearch = useStore(useSearchState, (state) => state?.selectedSearch);

  return (
    <Search
      styleType="flat"
      onOpen={onOpen}
    >
      <Search.Trigger>
        <Input
          startIcon={faSearch}
          startIconStyle="text-gray-500 text-xl"
          className="w-full cursor-pointer"
          inputClassName="cursor-pointer"
          value={selectedSearch?.displayName}
          data-testid="search-section-input"
          shouldClearValue={false}
          placeholder="Busque pela especialidade"
          {...props}
        />
      </Search.Trigger>
    </Search>
  );
}
